import React, { memo, useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  formatterPercentBarChartDataSet,
  getTranslationAnswerByQuantity,
} from '../../../../shared/utils/smartutils';
import ChartHorizontalBars from '../../../../shared/components/ChartHorizontalBars';
import colors from '../../../../shared/utils/colors';

const SummarySelectionAnswer = ({ answer }) => {
  const htmlRef = useRef(null);
  const { question, chartData } = answer;

  const hasData = () => {
    return !!chartData && chartData.length;
  };

  const getLabels = () => {
    let labels = [];
    if (hasData()) {
      labels = chartData.map((data) => data.label);
    }
    return labels;
  };

  const getNumbersChart = () => {
    let labels = [];
    if (hasData()) {
      labels = chartData.map((data) => data.value);
    }
    return labels;
  };

  const options = {
    animation: {
      duration: 0,
    },
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            min: 0,
            stepSize: 1,
          },
        },
      ],

      yAxes: [
        {
          stacked: false,
        },
      ],
    },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      datalabels: {
        formatter: (value, ctx) =>
          formatterPercentBarChartDataSet(value, ctx, question.numberOfAnswer),
        color: 'white',
        anchor: 'center',
        align: 'center',
        offset: 10,
      },
    },
  };

  const data = {
    labels: getLabels(),
    datasets: [
      {
        data: getNumbersChart(),
        backgroundColor: colors[0],
      },
    ],
  };

  useEffect(() => {
    if (question && htmlRef) {
      htmlRef.current.innerHTML = question.description;
    }
  }, [question]);

  return (
    <div className="mb-3 bg-light p-3">
      <div ref={htmlRef} className="mb-3" />
      <div className="mb-3">
        {`${question.numberOfAnswer} ${getTranslationAnswerByQuantity(
          question.numberOfAnswer
        )}`}
      </div>
      <div className="d-flex align-items-center">
        <div className="flex-2">
          <ChartHorizontalBars
            data={data}
            options={options}
            height={200}
            legend={{
              display: false,
            }}
          />
        </div>
      </div>
    </div>
  );
};

SummarySelectionAnswer.propTypes = {
  answer: PropTypes.shape({
    question: PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.number,
      type: PropTypes.string,
      numberOfAnswer: PropTypes.number,
    }),
    chartData: PropTypes.arrayOf(
      PropTypes.shape({
        descritiveAnswer: PropTypes.string,
        falseQuantity: PropTypes.number,
        label: PropTypes.string,
        responsible: PropTypes.string,
        trueQuantity: PropTypes.number,
        value: PropTypes.number,
      })
    ),
  }).isRequired,
};

export default withTranslation('common')(memo(SummarySelectionAnswer));
